import { Config } from './interfaces/FrenkitSearchProps'; // Importamos la interfaz desde el archivo de tipos

// Función para obtener la configuración
export async function getConfig(): Promise<string> {
    const response = await fetch('/modules/frenkitsearch/react/search/config.json');
    const config: Config = await response.json();
    return config.apiUrl;
  }